<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-30">
        <el-container>
          <el-aside width="330px">
            <sidebar></sidebar>
          </el-aside>
          <el-main>
           <companySide v-if="type" :isButton="isButton" @release="gorelease()"></companySide>
           <headSide v-else @release="gorelease()"></headSide>

            <!--列表-->
            <div v-if="showList == true"  style="margin-top:30px;">
             <paletteBar :paletteObj="paletteObj" @onPaletteBar="addNeeds()"></paletteBar>
              <div>
                  <div class="needs_list" v-for="(items,index) in demandList" :key="index">
                    <div class="fdc list_head">
                      <span class="list_title">{{items.type0=='1'?'[供应需求]':'[人力需求]'}}{{items.title}}</span>
                      <span class="list_date">{{items.createDate}}</span>
                    </div>
                  <div class="fdc list_heads">
                    <p class="fdc">
                    <span :class="[items.status ==1 || items.status ==2 ?'red':'']">{{items.status ==1?'待审核':items.status ==2?'审核不通过':items.status ==3?'未解决':items.status ==4?'已解决':items.status ==5?'已关闭':''}}</span>
                    <span style="margin-left:48px;">浏览数：{{items.readcount}}</span>
                    </p>
                    <p class="needs_list_tetx">
                      <span :class="[items.status ==5?'dn':'pl-15']"  @click.prevent="onClose(items)">关闭需求</span>
                      <span  @click.prevent="onEdit(items)">编辑需求</span>
                      <span class="pl-15" @click.prevent="onDelete(items)">删除需求</span>
                      <span class="pl-15 detail" @click.prevent="onView(items)">查看详情</span>
                    </p>
                  </div>
                  </div>
              </div>
                <!--分页-->
                <Pagination v-show="total>0"   :total="total"  :page.sync="listQuery.curPage" :limit.sync="listQuery.limit" @pageChange="pageChange" ></Pagination>
            </div>
           <!--查看详情-->
            <div v-if="hide == true" class="mt-30">
             <contTitle :obj="obj" :contTitle="contTitle" @onBacker="Backer()"></contTitle>
             <needsDetail :needsObj="demandObj"></needsDetail>
            </div>
            <!--浏览用户-->
            <div v-if="number == true " class="mt-30">
                  <contTitle :obj="obj1" :contTitle="contTitle2"></contTitle>
                  <pictureLeftList :list="nubmerList"  class="mt-20"></pictureLeftList>
                  <Pagination v-show="totals>0"   :total="totals"  :page.sync="dataQuery.curPage" :limit.sync="dataQuery.limit" @pageChange="pageNumber" ></Pagination>
            </div>
            <!---->
            <div style="margin-top:20%;">
                <notList :notCode="notCode"></notList>
            </div>

          </el-main>
        </el-container>
    </div>
  </div>
</template>

<script>
import {getDemand,delDemand,eitdDemandRecruit,eitdDemand ,closedDemand,closedDemandRecruit,myBrowseList} from "@/api/coment";
import sidebar from '../../common/sidebar'
import headSide from '../../common/headSide'
import companySide from "../../common/companySide";
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import paletteBar from '../../common/paletteBar'
import contTitle from '../../common/contTitle'
import needsDetail from '../../components/needsDetail'
import pictureLeftList from '../../components/pictureLeftList'
import Pagination from '../../components/Pagination'
import notList from '../../common/notList'
import {delDemandRecruit} from "../../api/coment";
export default {
   components:{
    sidebar,headSide,companySide,commBanner,titleHead,paletteBar,contTitle,needsDetail,pictureLeftList,Pagination,notList
   },
   data(){
     return{
       hide:false,
       showList:true,
       contTitle:'编辑需求',
       buttonText:'添加需求',
       contTitle2:'浏览用户',
       headTitle:'我的需求',
       obj:{
         title:'我的需求',
         isShow:false,
         backer:false,
         roleType:'',
         personalType:9
       },
        obj1:{
         title:'我的需求',
         isShow:false,
         roleType:'',
         personalType:9
       },
       paletteObj:{
          paletteTitle:'我发布的需求',
          paletteCount:'',
          isShow:true,
          paletteName:'发布需求'
        },
      remnant:50,//倒计数
      demandList:[], //需求列表
      listQuery:{
        curPage:1,
        limit:5
      },
       dataQuery:{
        curPage:1,
        limit:4,
        goodsType: 6,
        goodsId:''
      },
      total:0,//当前条数
      totals:0,
      demandObj:{},
      notCode:false,
      number:false,
      nubmerList:[],
      isButton:false,
      type:false,
     }
   },
   created(){
     this.getDemandList();
     if(this.$store.state.user.userInfo !=null){
         let type = this.$store.state.user.userInfo.type;
         this.obj.roleType = type;
         if(type == 3){
            this.type = true;
            this.headTitle ='企业需求'
            this.obj.title = '企业需求'
         }
     }

     if(this.$route.query.id != undefined){
        this.showList = false;
        this.notCode = false;
        this.getEitdDemand(this.$route.query.id);
     }
   },
   methods:{
	 //返回列表
	   Backer(){
	   this.hide = false
	   this.showList = true;
	   },
     //发布需求
     addNeeds(){
        this.showList = false;
        this.obj.backer = false;
        this.notCode = false;
        this.$router.push('/demandAdd')
     },
     //编辑需求
     onEdit(row){
       this.$router.push({
         path:'/demandAdd',
         query:{
           id:row.id,
           type0:row.type0
         }
       });
     },
     //查看详情
     onView(row){
       this.$router.push({
         path:'/demandDetail',
         query:{id:row.id,type0:row.type0}
       });
     },
      getEitdDemand(id){
      let params ={demandId:id};
      eitdDemand(params).then(res=>{
         if(res.code ==0){
           this.demandObj = res.data;
		   this.obj.backer = true;
         }
       }).catch(err=>{});
      },
    //查询需求列表
     getDemandList(){
      getDemand(this.listQuery).then((res)=>{
         if(res.code ==0){
           this.demandList = res.data.list;
           this.total = res.data.totalCount;
           this.paletteObj.paletteCount = res.data.totalCount;
		       this.demandList.length == 0 ? this.notCode = true : this.notCode = false;
         }
      }).catch((err)=>{});
     },
    //删除需求
     onDelete(row){
      let parmas ={demandId:row.id};
      this.$confirm('确定要删除吗','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
       }).then(()=>{
         if(row.type0=='1'){
           delDemand(parmas).then(res =>{
             if(res.code == 0){
               this.$message({
                 message:'删除成功！',
                 type: 'success',
                 duration:1000,
                 onClose:()=>{
                   this.getDemandList();
                 }
               });
             }
           }).catch(err=>{});

         }else{
           delDemandRecruit(parmas).then(res =>{
             if(res.code == 0){
               this.$message({
                 message:'删除成功！',
                 type: 'success',
                 duration:1000,
                 onClose:()=>{
                   this.getDemandList();
                 }
               });
             }
           }).catch(err=>{});
         }
      }).catch(()=>{
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })

     },
     //关闭需求
     onClose(row){
      let params ={demandId:row.id};
      if(row.type0=='1'){
        closedDemand(params).then(res=>{
          if(res.code == 0){
            this.$message({
              message:'关闭成功！',
              type: 'success',
              duration:1000,
              onClose:()=>{
                this.getDemandList();
              }
            });
          }
        }).catch(err=>{});
      }else{
        closedDemandRecruit(params).then(res=>{
          if(res.code == 0){
            this.$message({
              message:'关闭成功！',
              type: 'success',
              duration:1000,
              onClose:()=>{
                this.getDemandList();
              }
            });
          }
        }).catch(err=>{});
      }
     },

    //浏览人数列表
    getNubmer(){
      myBrowseList(this.dataQuery).then((res)=>{
        if(res.code ==0){
          this.nubmerList = res.page.list;
          this.totals = res.page.totalCount;
          res.page.list.length >0 ? this.number = true : this.number = false;
        }
      }).catch((err)=>{})
    },
    //发布需求分页
    pageChange(item){
      this.listQuery['curPage'] = item.page;
      this.listQuery['limit'] = item.limit;
      this.getDemandList();
    },
	//查询浏览人数
    pageNumber(item){
      this.dataQuery['curPage'] = item.page;
      this.dataQuery['limit'] = item.limit;
      this.getNubmer();
    }
   }
}
</script>

<style scoped>
.pl-15{
  padding-left: 15px;
}
.tel{
  text-align: left;
}
.dn{
  display: none;
}
.red{
  color: #ff7171 !important;
}
.mt-15{
  margin-top: 15px;
}
.mt-20{
  margin-top: 20px;
}
.info_form>>>.el-input--suffix .el-input__inner{
  height: 50px;
}
.needs_list{
  width: 100%;
  height: 103px;
  margin-top: 20px;
  border: 1px solid #DEDEDE;
  transition: all 0.5s;
}
.needs_list:hover{
   box-shadow: 0 0 20px #ddd;
}
.list_head{
  margin: 0px 20px;
  padding-top: 15px;
}
.list_title{
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}
.list_date{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.list_heads{
   margin: 0px 20px;
   padding-top: 14px;
}
.list_heads p span{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.list_heads p span.detail{
 color: #333333;
}

.needs_list_tetx:hover{
  cursor: pointer;
}
.needs_list_tetx span:hover{
   color: #FF7302;
}
.el-form-item{
    text-align: left;
}
.info_form >>>.el-textarea__inner{
  /* width:px; */
  height: 169px;
}

.tel button {
  width: 129px;
  height: 35px;
  background: #3BBB35;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  text-align:center;
  line-height: 1px;
}
.text_center{
	font-size: 14px;
	font-family: Microsoft YaHei;
	font-weight: 400;
	color: #333333;
}
.el-pagination{
   margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/coment/demand.vue